module.exports = __webpack_public_path__ + "img/photo-analysis-icon.492b2770.svg";